import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class WBSNonleafError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, additionalData) {
    super(reportService, 'One or more cost/hour line items mapped to non-leaf WBS node', 'WBS_NON_LEAF_ERROR', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/WBSNonleafError.ts